module.exports = __webpack_public_path__ + "static/media/actividades.36ccaba8.png";